<template>
  <div class="wrapping-box-container main-content--container">
    <div id="controls" class="controls"></div>

    <loading-spinner class="main-content--spinner"/>

  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { FaceTec } from '@/services/facetec';
import LoadingSpinner from '../../paymentLink/components/LoadingSpinner.vue';
import logger from '../../../lib/logger';

export default {
  name: 'v2-onboarding-selfie-camera-facetec',
  components: { LoadingSpinner },
  async mounted() {
    try {
      const { success } = await FaceTec.openSession();
      if (success) FaceTec.onLivenessCheckPressed();
    } catch (error) {
      logger.error(error);
      this.$router.replace({
        name: 'v2-onboarding-error',
        query: this.$route.query,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  .main-content--container {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .main-content--spinner {
    align-self: center;
  }
</style>
